import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { GroupAnalysis } from '@cli-types/next-adapter/forms.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { collectRelationshipFields } from '@next-adapter/generators/form/form-shared/collect-relationship-fields.js'
import { hasNestedObjectListField } from '@next-adapter/generators/form/form-shared/has-nested-object-list-field.js'

export function analyzeGroup(fields: SchemaField[]): GroupAnalysis {
  const tabFieldNames = new Set<string>()
  for (const f of fields) {
    if (f.type === 'tabs' && f.tabs) {
      for (const tab of f.tabs) {
        if (tab.fields) for (const tf of tab.fields) tabFieldNames.add(tf.name)
      }
    }
  }

  const relFields = collectRelationshipFields(fields, tabFieldNames)
  const multiSelectFields = flattenFields(fields).filter(
    (f) => f.type === 'select' && f.multiple === true
  )

  const listFieldsWithNested: SchemaField[] = []
  function collectLists(flds: SchemaField[]): void {
    for (const f of flds) {
      if (f.type === 'list' && f.fields && f.fields.length > 0 && !f.hidden) {
        listFieldsWithNested.push(f)
      }
      if (f.type === 'group' && f.fields) collectLists(f.fields)
      if (f.type === 'tabs' && f.tabs) {
        for (const tab of f.tabs) {
          if (tab.fields) collectLists(tab.fields)
        }
      }
    }
  }
  collectLists(fields)

  const hasTabsField = fields.some((f) => f.type === 'tabs')

  return {
    relFields,
    multiSelectFields,
    listFieldsWithNested,
    hasNestedObjectList: hasNestedObjectListField(fields),
    hasTabsField,
    tabFieldNames
  }
}
